import React from 'react';
import { styles } from './DropdownHeading.css';
import { ArrowLeft } from '@jbhi-fi/lanyard-ui/components/Icons';
import { palette } from '@jbhi-fi/lanyard-ui/themes';

export type DropdownHeadingProps = {
  label: string;
  onBack?: (e: React.MouseEvent) => void;
};

export const DropdownHeading = ({ label, onBack }: DropdownHeadingProps) => {
  return (
    <div className={styles.labelWrapper} data-testid="navigation-menu-dropdown-heading">
      {onBack ? (
        <button className={styles.button} onClick={onBack} data-testid="navigation-menu-dropdown-back-button">
          <ArrowLeft className={styles.backIcon} color={palette.primary.light} />
          Back
        </button>
      ) : null}
      <h4 className={styles.label}>{label}</h4>
    </div>
  );
};
